// flexi app onboarding banner logic removed — the flexi sections app is uninstalled,
// so the #flexi-checker element it injected never exists and the banner was showing
// on every page with a flexi section. accordion logic below is still in use.

const onClickAccordionHeader = e => {
    const parentAccordion = e.currentTarget.closest('.accordion');
    const accordionItems = parentAccordion.querySelectorAll('.accordion-item');

    if (e.currentTarget.parentNode.classList.contains('active')) {
      e.currentTarget.parentNode.classList.remove("active");
    } else {
      Array.prototype.forEach.call(accordionItems, e => e.classList.remove('active'));
      e.currentTarget.parentNode.classList.add("active");
    }
};

const initAccordion = () => {
    const accordionItem = document.querySelectorAll('.accordion-item');
    Array.prototype.forEach.call(accordionItem, e => e.querySelector('.accordion-header').addEventListener('click', onClickAccordionHeader, false));
};

document.addEventListener('DOMContentLoaded', initAccordion);
  

document.addEventListener("DOMContentLoaded", function() {
// Check if the URL contains '#view-product'
if(window.location.hash === '#scroll-point') {
    // Scroll to the top of the page
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

// Add event listener to all links with href '#view-product'
const viewProductLinks = document.querySelectorAll("a[href='#scroll-point']");
viewProductLinks.forEach(function(viewProductLink) {
    viewProductLink.addEventListener("click", function(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    });
});
});